const imgixProductURL = (url) => String(url).replace(/(-small|-listing|-medium|-large|-full|-zoom)?\.([^.]+)$/, '-zoom.$2').replace(process.env.REACT_CENTRA_CDN_PATH, process.env.REACT_IMGIX_CDN_PATH);
const imgixImageURL = (url) => String(url).replace(/^(https?:)?\/\/[^/]+?\/(app\/)?/, process.env.REACT_IMGIX_IMAGE_CDN_PATH);

export const isImageLoaded = ($img) => {
	if (!$img.complete) return false;
	if (typeof $img.naturalWidth !== 'undefined' && $img.naturalWidth === 0) return false;
	return true;
};

// export const imageSizeTranslation = (columnWidth, imageObj, limitLower = false) => {
export const imageSizeTranslation = (columnWidth = '', imageObj = {}, lazyLoad = true, limitLower = false, imageWidth = false, product = false) => {
	const returnObj = {};
	const useLazy = lazyLoad !== false;
	let width = 1;
	columnWidth = String(columnWidth);
	if (!imageObj || Object.keys(imageObj).length === 0) return {};
	if (imageObj.src) imageObj.url = imageObj.src;
	if (/\.(svg|gif)$/.test(imageObj.url)) columnWidth = 'noResize';
	if (!product) imageObj.url = imgixImageURL(imageObj.url);

	if (useLazy && lazyLoad === 'eager') returnObj.loading = 'eager';
	else if (useLazy) returnObj.loading = 'lazy';
	if (imageWidth !== false) {
		returnObj.src = `${imageObj.url}?w=${imageWidth}&auto=format,compress`;
		returnObj.alt = imageObj.alt;
		returnObj.width = imageWidth;
		if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * imageWidth);
		return returnObj;
	}

	switch (columnWidth) {
		case 'full':
			width = 2600;
			returnObj.src = `${imageObj.url}?w=2600&auto=format,compress`;
			returnObj.srcSet = `${imageObj.url}?w=2600&auto=format,compress 2600w, ${imageObj.url}?w=2400&auto=format,compress 2400w, ${imageObj.url}?w=1800&auto=format,compress 1800w, ${imageObj.url}?w=800&auto=format,compress 800w, ${imageObj.url}?w=400&auto=format,compress 400w`;
			break;
		case '12':
		case '11':
		case '10':
			width = 2400;
			returnObj.src = `${imageObj.url}?w=2400&auto=format,compress`;
			returnObj.srcSet = `${imageObj.url}?w=2400&auto=format,compress 2400w, ${imageObj.url}?w=1800&auto=format,compress 1800w, ${imageObj.url}?w=1200&auto=format,compress 1200w, ${imageObj.url}?w=600&auto=format,compress 600w`;
			break;
		case '9':
		case '8':
		case '7':
			width = 1800;
			returnObj.src = `${imageObj.url}?w=1800&auto=format,compress`;
			returnObj.srcSet = `${imageObj.url}?w=1800&auto=format,compress 1800w, ${imageObj.url}?w=1200&auto=format,compress 1200w, ${imageObj.url}?w=600&auto=format,compress 600w`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 600px) 100vw, ')}75vw`;
			break;
		case '6':
		case '5':
		case '4':
			width = 1200;
			returnObj.src = `${imageObj.url}?w=1200&auto=format,compress`;
			returnObj.srcSet = `${imageObj.url}?w=1200&auto=format,compress 1200w, ${imageObj.url}?w=600&auto=format,compress 600w`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 600px) 100vw, ')}50vw`;
			break;
		case '3':
		case '2':
		case '1':
			width = 600;
			returnObj.src = `${imageObj.url}?w=600&auto=format,compress`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 600px) 50vw, ')}25vw`;
			break;
		default:
			width = imageObj.width;
			returnObj.src = imageObj.url;
	}
	returnObj.alt = imageObj.alt;
	returnObj.width = width;
	if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * width);

	return returnObj;
};

export const productImageSizeTranslation = (columnWidth = '', image = '', lazyLoad = true, limitLower = false, imageWidth = false) => (
	imageSizeTranslation(columnWidth, { url: imgixProductURL(image) }, lazyLoad, limitLower, imageWidth, true)
);
